/**
 * User TakeOut Route - React Router v7
 *
 * Route: /user/takeout
 * Description: User data export/download (GDPR data takeout)
 */
import type {LoaderFunctionArgs} from 'react-router-dom'
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-throw-literal, @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-nullish-coalescing, @typescript-eslint/no-unused-vars */
import {useLoaderData, useLocation} from 'react-router-dom'

import Context from '@s-ui/react-context'

import UserTakeOutRaw from './index.js'

// Import styles
import './styles/index.scss'
// HOC wrapping that used to live in `./index.js`. Moved here so `./index.js`
// exports the raw component and receives Fast Refresh in dev.
const UserTakeOut = Context.wrapper(UserTakeOutRaw, 'TakeOut')

/**
 * Loader for User TakeOut page
 * Resolves the page name the legacy getInitialProps used to provide.
 */
export async function loader({context, request}: LoaderFunctionArgs) {
  const {domain} = context
  const path = new URL(request.url).pathname

  try {
    const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})
    return {pageName}
  } catch (error) {
    console.error('[UserTakeOut] Loader error:', error)
    return {pageName: 'user-account-take-out'}
  }
}

/**
 * Component wrapper
 * The page reads `location.pathname` for the auth redirect, a prop the legacy router injected.
 */
export function Component() {
  const data = useLoaderData()
  const location = useLocation()
  return <UserTakeOut {...data} location={location} />
}

export default {loader, Component}
